import { Box } from '@mui/material';
import {
  InputProps,
  regex,
  required,
  SimpleFormIterator,
  TextInput,
  WrapperField,
  Labeled,
  FunctionField,
  useRecordContext,
} from 'react-admin';
import { IntegrationRecord } from '../../../common/types';
import IntegrationInfo from './IntegrationInfo';
import StyledArrayInput from './StyledArrayInput';

const WebhookUrl = () => {
  const record = useRecordContext();

  if (!record?.id) return null;

  const urlBase = 'https://it3.suitepad.systems/v2/webhooks/duve/';

  return (
    <Labeled label="resources.integrations.fields.duve.webhookUrl.label">
      <FunctionField render={() => urlBase + record.integrationUuid} />
    </Labeled>
  );
};

const DuveInputs = ({
  integration,
}: Omit<InputProps, 'source'> & { integration: IntegrationRecord }) => (
  <WrapperField>
    <IntegrationInfo integration={integration} />
    <Box width="70%" maxWidth="70%">
      <TextInput
        source="currentConfig.service.webhook_secret"
        label="resources.integrations.fields.duve.webhook_secret.label"
        helperText="resources.integrations.fields.duve.webhook_secret.helperText"
        validate={required(
          'resources.integrations.fields.duve.webhook_secret.helperText'
        )}
        variant="outlined"
        fullWidth
      />
      <StyledArrayInput
        source="currentConfig.service.check_in_statuses"
        label="resources.integrations.fields.duve.check_in_statuses.label"
        helperText="resources.integrations.fields.duve.check_in_statuses.helperText"
        variant="outlined"
        validate={required(
          'resources.integrations.fields.duve.check_in_statuses.helperText'
        )}
        fullWidth
      >
        <SimpleFormIterator disableReordering>
          <TextInput
            source=""
            label="resources.integrations.fields.duve.check_in_status.label"
            helperText="resources.integrations.fields.duve.check_in_status.helperText"
            variant="outlined"
            fullWidth
          />
        </SimpleFormIterator>
      </StyledArrayInput>
      <StyledArrayInput
        source="currentConfig.service.check_out_statuses"
        label="resources.integrations.fields.duve.check_out_statuses.label"
        helperText="resources.integrations.fields.duve.check_out_statuses.helperText"
        variant="outlined"
        validate={required(
          'resources.integrations.fields.duve.check_out_statuses.helperText'
        )}
        fullWidth
      >
        <SimpleFormIterator disableReordering>
          <TextInput
            source=""
            label="resources.integrations.fields.duve.check_out_status.label"
            helperText="resources.integrations.fields.duve.check_out_status.helperText"
            variant="outlined"
            fullWidth
          />
        </SimpleFormIterator>
      </StyledArrayInput>
      <TextInput
        source="currentConfig.service.timezone"
        label="resources.integrations.fields.duve.timezone.label"
        helperText="resources.integrations.fields.duve.timezone.helperText"
        validate={required(
          'resources.integrations.fields.duve.timezone.helperText'
        )}
        variant="outlined"
        fullWidth
      />
      <TextInput
        source="currentConfig.service.check_in_time"
        label="resources.integrations.fields.duve.check_in_time.label"
        helperText="resources.integrations.fields.duve.check_in_time.helperText"
        validate={regex(
          /^([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/,
          'resources.integrations.fields.duve.check_in_time.helperText'
        )}
        variant="outlined"
        fullWidth
        defaultValue="12:00:00"
      />
      <TextInput
        source="currentConfig.service.check_out_time"
        label="resources.integrations.fields.duve.check_out_time.label"
        helperText="resources.integrations.fields.duve.check_out_time.helperText"
        validate={regex(
          /^([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/,
          'resources.integrations.fields.duve.check_out_time.helperText'
        )}
        variant="outlined"
        fullWidth
        defaultValue="10:00:00"
      />
      <WebhookUrl />
    </Box>
  </WrapperField>
);

export default DuveInputs;
